function getPlazasZona(el, capa, title) {
  jQuery.ajax({
    type: 'POST',
    async: true,
    url: rutajs + 'lib/ajax.php',
    data: 'fn=getPlazasZona&zona=' + $(el).val(),
    success: function (data) {
      $('#' + capa).html(data);

      if ($('#' + title).length > 0) {
        $('#' + title).html($(el).find(':selected').text().toUpperCase());
      }

      document.cookie =
        'combozona=' + $(el).val() + '; expires=Thu, 18 Dec 2125 12:00:00 UTC';
    },
  });
}

function goToUrlComboZona() {
  var option = $('#zona option:selected');

  if (option.val() !== '-1') {
    window.location.href = option.data('url');
  }
}